import plattixCrmUIReducers from "PlattixSalesUI/configuration/reducers";


export const reducers = {

    ...plattixCrmUIReducers
}